// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-search-box----styles-module---container---2CNmU"};


//////////////////
// WEBPACK FOOTER
// ./src/components/search-box/styles.module.css
// module id = 150
// module chunks = 73713890734725 85208315989496 142807904292071